<template>
  <div class="bash-box function-box">
    <p class="h2-title">{{ indata.FirstTitle }}</p>
    <ul class="function-ul">
      <li
        v-for="(item, index) in indata.children"
        :class="index % 2 == 0 ? '' : 'right'"
        :key="index"
      >
        <div>
          <p class="h3">{{ item.title1 }}</p>
          <p class="detail">{{ item.title2 }}</p>
          <a class="go-next" :href="item.btnUrl" target="_blank">免费试用</a>
        </div>
        <img :src="item.image" alt="" />
      </li>
    </ul>
  </div>
</template>
<style scoped src="../../public/css/drp.css">
</style>
<script>
export default {
  name: "Templates7",
  props: {
    indata: Array,
  },
  data() {
    return {
      NowIndex: 0,
    };
  },
  methods: {
    changeActive(index) {
      this.NowIndex = index;
    },
  },
};
</script>
